// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/international-payment/international-payment.component.scss
// module id = 709
// module chunks = 0